export default {
  LOW_VALUE: 'Low value',
  MEDIUM_VALUE: 'Medium value',
  HIGH_VALUE: 'High value',
};
